import { useCachedImage } from "../hooks/useCacheImage"

const CachedImage = ({ src, alt, className }) => {
    const image = useCachedImage(src);

    return (<img src={image} alt={alt} className={className} />)
}

export default CachedImage;
